export default __webpack_public_path__ + "static/media/(19).3625ee0a.jpeg";